import envConfig from '../env-config.json'

let apiUrl = envConfig.jobs.env.dev
let imageHandler = envConfig.imageHandler

if (process.env.NODE_ENV === 'production') {
  apiUrl = envConfig.jobs.env.production
}

export { apiUrl, imageHandler }



// WEBPACK FOOTER //
// ./src/services/env.js